(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jlb-chambre"] && !Shopify.designMode) return;
  try {
    
  // ── Wishlist ──
  (function() {
    var JLB_FAV_KEY = 'jlb_wishlist';
    function getFavHandles() {
      try { return JSON.parse(localStorage.getItem(JLB_FAV_KEY)) || []; } catch(e) { return []; }
    }
    window.jlbToggleFav = window.jlbToggleFav || function(e, handle) {
      e.preventDefault(); e.stopPropagation();
      var favs = getFavHandles();
      var idx = favs.indexOf(handle);
      var action = idx === -1 ? 'add' : 'remove';
      if (action === 'add') { favs.push(handle); } else { favs.splice(idx, 1); }
      localStorage.setItem(JLB_FAV_KEY, JSON.stringify(favs));
      e.currentTarget.classList.toggle('active', action === 'add');
      if (typeof window.jlbServerSync === 'function') window.jlbServerSync(handle, action);
    };
    document.addEventListener('DOMContentLoaded', function() {
      var favs = getFavHandles();
      document.querySelectorAll('.jlb-fav-btn[data-handle]').forEach(function(btn) {
        if (favs.indexOf(btn.dataset.handle) !== -1) btn.classList.add('active');
      });
    });
  })();

  // ── Reveal on scroll ──
  const reveals = document.querySelectorAll('.jlb-ch-reveal');
  const revealObs = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-visible'); revealObs.unobserve(e.target); } });
  }, { threshold: 0.12 });
  reveals.forEach(el => revealObs.observe(el));

  // ── Essentiels carousel ──
  const track   = document.getElementById('jlbEssentielsTrack');
  const btnPrev = document.getElementById('jlbEssPrev');
  const btnNext = document.getElementById('jlbEssNext');

  if (track && btnPrev && btnNext) {
    const cards = track.querySelectorAll('.jlb-ch-ess-card');
    const total = cards.length;
    let current = 0;

    function scrollTo(idx) {
      current = Math.max(0, Math.min(idx, total - 1));
      cards[current].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }

    btnNext.addEventListener('click', () => scrollTo(current + 1));
    btnPrev.addEventListener('click', () => scrollTo(current - 1));

    track.addEventListener('scroll', () => {
      clearTimeout(track._t);
      track._t = setTimeout(() => {
        const cardW = cards[0].offsetWidth + 20;
        current = Math.round(track.scrollLeft / cardW);
      }, 80);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlb-collection"] && !Shopify.designMode) return;
  try {
    
(function() {
  var JLB_FAV_KEY = 'jlb_wishlist';
  function getFavHandles() {
    try { return JSON.parse(localStorage.getItem(JLB_FAV_KEY)) || []; } catch(e) { return []; }
  }
  window.jlbToggleFav = window.jlbToggleFav || function(e, handle) {
    e.preventDefault(); e.stopPropagation();
    var favs = getFavHandles();
    var idx = favs.indexOf(handle);
    var action = idx === -1 ? 'add' : 'remove';
    if (action === 'add') { favs.push(handle); } else { favs.splice(idx, 1); }
    localStorage.setItem(JLB_FAV_KEY, JSON.stringify(favs));
    e.currentTarget.classList.toggle('active', action === 'add');
    if (typeof window.jlbServerSync === 'function') window.jlbServerSync(handle, action);
  };
  document.addEventListener('DOMContentLoaded', function() {
    var favs = getFavHandles();
    document.querySelectorAll('.jlb-fav-btn[data-handle]').forEach(function(btn) {
      if (favs.indexOf(btn.dataset.handle) !== -1) btn.classList.add('active');
    });
    document.querySelectorAll('.jlb-card-rating[data-rating]').forEach(function(el) {
      var rating = parseFloat(el.dataset.rating) || 0;
      var count = parseInt(el.dataset.count) || 0;
      var pct = (rating / 5 * 100).toFixed(1);
      var fill = el.querySelector('.jlb-card-rating__stars-fill');
      var countEl = el.querySelector('.jlb-card-rating__count');
      if (fill) fill.style.width = pct + '%';
      if (countEl) countEl.textContent = '(' + count + ')';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlb-contact"] && !Shopify.designMode) return;
  try {
    
  // FAQ accordion
  document.querySelectorAll('[data-faq]').forEach(item => {
    const btn = item.querySelector('.jlb-ct-faq__question');
    const answer = item.querySelector('.jlb-ct-faq__answer');
    btn.addEventListener('click', () => {
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      // Ferme tous les autres
      document.querySelectorAll('[data-faq]').forEach(other => {
        other.querySelector('.jlb-ct-faq__question').setAttribute('aria-expanded', 'false');
        other.querySelector('.jlb-ct-faq__answer').style.maxHeight = '0';
      });
      if (!isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlb-cuisine"] && !Shopify.designMode) return;
  try {
    
  // Carousel
  const track = document.getElementById('jlbCuTrack');
  const prev  = document.getElementById('jlbCuPrev');
  const next  = document.getElementById('jlbCuNext');
  if (track && prev && next) {
    let idx = 0;
    const cards = track.querySelectorAll('.jlb-cu-ess-card');
    const total = cards.length;
    function goTo(n) {
      idx = Math.max(0, Math.min(n, total - 1));
      const w = cards[0].offsetWidth + 24;
      track.style.transform = 'translateX(-' + (idx * w) + 'px)';
    }
    prev.addEventListener('click', () => goTo(idx - 1));
    next.addEventListener('click', () => goTo(idx + 1));
  }

  // Reveal on scroll
  const reveals = document.querySelectorAll('.jlb-cu-reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.15 });
    reveals.forEach(el => io.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('is-visible'));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlb-header"] && !Shopify.designMode) return;
  try {
    
  // Search overlay
  const searchToggle  = document.getElementById('jlbSearchToggle');
  const searchOverlay = document.getElementById('jlbSearchOverlay');
  const searchClose   = document.getElementById('jlbSearchClose');
  const searchBackdrop= document.getElementById('jlbSearchBackdrop');
  const searchInput   = document.getElementById('jlbSearchInput');

  function openSearch() {
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    searchToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    setTimeout(function() { searchInput.focus(); }, 100);
  }
  function closeSearch() {
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    searchToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (searchToggle) searchToggle.addEventListener('click', openSearch);
  if (searchClose)  searchClose.addEventListener('click', closeSearch);
  if (searchBackdrop) searchBackdrop.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeSearch();
  });

  // Scroll shadow
  const hdr = document.getElementById('jlbHeader');
  if (hdr) {
    window.addEventListener('scroll', () => {
      hdr.classList.toggle('is-scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // Banner infinite marquee
  (function() {
    const track = document.getElementById('jlbBannerTrack');
    if (!track) return;
    // Measure one set of items
    const oneSetWidth = track.scrollWidth;
    // Clone until we have at least 3x viewport
    const copies = Math.ceil((window.innerWidth * 3) / oneSetWidth) + 1;
    for (let i = 0; i < copies; i++) {
      const fragment = document.createDocumentFragment();
      track.querySelectorAll('.jlb-hdr-banner__item, .jlb-hdr-banner__sep').forEach(function(el) {
        const clone = el.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        fragment.appendChild(clone);
      });
      track.appendChild(fragment);
    }
    let x = 0;
    const speed = 0.55;
    function tick() {
      x += speed;
      if (x >= oneSetWidth) x -= oneSetWidth;
      track.style.transform = 'translateX(-' + x + 'px)';
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  })();

  // Mobile drawer
  const burger  = document.getElementById('jlbBurger');
  const drawer  = document.getElementById('jlbDrawer');
  const overlay = document.getElementById('jlbDrawerOverlay');
  const closeBtn= document.getElementById('jlbDrawerClose');

  function openDrawer() {
    drawer.classList.add('is-open');
    burger.classList.add('is-open');
    burger.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    burger.classList.remove('is-open');
    burger.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (burger) burger.addEventListener('click', openDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlb-salle-de-bain"] && !Shopify.designMode) return;
  try {
    
  const track = document.getElementById('jlbSbTrack');
  const prev  = document.getElementById('jlbSbPrev');
  const next  = document.getElementById('jlbSbNext');
  if (track && prev && next) {
    let idx = 0;
    const cards = track.querySelectorAll('.jlb-sb-ess-card');
    const total = cards.length;
    function goTo(n) {
      idx = Math.max(0, Math.min(n, total - 1));
      const w = cards[0].offsetWidth + 24;
      track.style.transform = 'translateX(-' + (idx * w) + 'px)';
    }
    prev.addEventListener('click', () => goTo(idx - 1));
    next.addEventListener('click', () => goTo(idx + 1));
  }

  const reveals = document.querySelectorAll('.jlb-sb-reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.15 });
    reveals.forEach(el => io.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('is-visible'));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlb-salon"] && !Shopify.designMode) return;
  try {
    
  // Carousel
  const track = document.getElementById('jlbSlTrack');
  const prev  = document.getElementById('jlbSlPrev');
  const next  = document.getElementById('jlbSlNext');
  if (track && prev && next) {
    let idx = 0;
    const cards = track.querySelectorAll('.jlb-sl-ess-card');
    const total = cards.length;
    function goTo(n) {
      idx = Math.max(0, Math.min(n, total - 1));
      const w = cards[0].offsetWidth + 24;
      track.style.transform = 'translateX(-' + (idx * w) + 'px)';
    }
    prev.addEventListener('click', () => goTo(idx - 1));
    next.addEventListener('click', () => goTo(idx + 1));
  }

  // Reveal on scroll
  const reveals = document.querySelectorAll('.jlb-sl-reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.15 });
    reveals.forEach(el => io.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('is-visible'));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
